import { render, staticRenderFns } from "./cgorderpriceSp.vue?vue&type=template&id=5c283505&scoped=true"
import script from "./cgorderpriceSp.vue?vue&type=script&lang=js"
export * from "./cgorderpriceSp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c283505",
  null
  
)

export default component.exports